import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { StylesProvider } from '@material-ui/core/styles';
import App from "./App";
import "./index.css";
import * as serviceWorker from './serviceWorker';
import storage from './utils/storage';
import { installGlobalErrorHandlers } from './helpers/clientErrorReporter';
import { installFocusModality } from './helpers/focusModality';

// O index.html de produção pode ficar em cache ou num deploy que só levou src/.
// Sem este link a casca pede Schibsted e o navegador cai na fonte do sistema.
const SCHIBSTED_STYLESHEET =
  "https://fonts.googleapis.com/css2?family=Schibsted+Grotesk:wght@400;500;600;700&display=swap";

function ensureShellFont() {
  if (typeof document === "undefined") return;
  if (document.querySelector('link[data-omni-font="schibsted"]')) return;
  const preconnect = document.createElement("link");
  preconnect.rel = "preconnect";
  preconnect.href = "https://fonts.gstatic.com";
  preconnect.crossOrigin = "anonymous";
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = SCHIBSTED_STYLESHEET;
  link.setAttribute("data-omni-font", "schibsted");
  document.head.appendChild(preconnect);
  document.head.appendChild(link);
}

ensureShellFont();

// ✅ Suprimir erro benigno do ResizeObserver (comum com drag & drop)
// Este erro não afeta a funcionalidade da aplicação
// Solução: Sobrescrever ResizeObserver para debounce as notificações
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // Usar requestAnimationFrame para evitar o erro de loop
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

// Em dev, limpar apenas cache do SW (não o registro) para permitir Web Push
if (process.env.NODE_ENV === 'development' && 'serviceWorker' in navigator && 'caches' in window) {
  caches.keys().then(cacheNames => {
    cacheNames.forEach(cacheName => caches.delete(cacheName));
  });
}

// ✅ Limpar localStorage expirado/desatualizado ao iniciar
storage.cleanExpired();
console.log('[App] localStorage limpo. Stats:', storage.getStats());

// Telemetria de erro (window.onerror + unhandledrejection → /api/client-errors, só logado)
installGlobalErrorHandlers();

installFocusModality();

ReactDOM.render(
  <React.StrictMode>
    <StylesProvider injectFirst>
      <CssBaseline>
        <App />
      </CssBaseline>
    </StylesProvider>
  </React.StrictMode>,
  document.getElementById("root"),
  () => {
    if (typeof window.finishProgress === "function") {
      setTimeout(() => {
        window.finishProgress();
      }, 300);
    }
  }
);

// Service Worker em produção e desenvolvimento (necessário para Web Push)
serviceWorker.register();

// ✅ Limpar localStorage periodicamente (a cada 1 hora)
setInterval(() => {
  storage.cleanExpired();
}, 60 * 60 * 1000);
